<script>
    import { jwt } from './store.js';
	import { navigate } from 'svelte-navigator';

    let username = '';
    let password = '';
    let error = undefined;

    const handleLogin = async () => {
        error = undefined;
        const response = await fetch('https://api.abittel.fr/movie/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 'username': username, 'password': password })
        });

        const data = await response.json();

        if (data.token) {
            localStorage.setItem('token', data.token);
            $jwt = data.token;
            navigate('/');
        } else {
            error = "Invalid username or password";
        }
    }
</script>

<style>
    .login {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        color: white;
        font-family: Arial, sans-serif;
    }

    form {
        display: flex;
        flex-direction: column;
        width: 300px;
        padding: 20px;
        border-radius: 5px;
        background-color: rgba(0, 0, 0, 0.7);
    }

    label {
        margin-bottom: 10px;
    }

    input {
        margin-bottom: 20px;
        padding: 10px;
        border-radius: 5px;
        border: none;
    }

    button {
        padding: 10px;
        border-radius: 5px;
        border: none;
        background-color: #667aff;
        color: white;
        cursor: pointer;
    }

    button:hover {
        background-color: #354190;
    }
</style>

<div class="login">
    <form on:submit|preventDefault={handleLogin}>
        <label for="username">Username:</label>
        <input id="username" bind:value={username} type="text" required>

        <label for="password">Password:</label>
        <input id="password" bind:value={password} type="password" required>

        {#if error}
            <p style="color: red;">{error}</p>
        {/if}

        <button type="submit">Login</button>
    </form>
</div>